const translations = {
  title: 'Creating screen presentation',
  title_edit: 'Editing screen presentation',
  title_cloning: 'Cloning screen presentation',
  name: 'Name*',
  userGroups: 'User groups',
  columnTitle: 'Creating column',
  columnTitle_edit: 'Editing column',
  columnTitle_cloning: 'Cloning column',
  color: 'Color',
  filters: 'Filters',
  widgetTitle: 'Adding widget',
  widgetTitle_edit: 'Editing widget',
  selectWidget: 'Select a widget'
}

export default translations
